import { Calculator, FlaskConical, BookOpenText, Globe2, Languages, Leaf, Monitor, ScrollText } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";

const boards = ["CBSE", "ICSE", "State Boards"];

const subjects = [
  { icon: Calculator, name: "Mathematics", desc: "Numbers, geometry & problem-solving with strong fundamentals.", tone: "primary" },
  { icon: FlaskConical, name: "Science", desc: "Curiosity-led concepts across physics, chemistry & biology basics.", tone: "white", border: "border-4 border-primary" },
  { icon: BookOpenText, name: "English", desc: "Reading, grammar, writing & comprehension for confident expression.", tone: "white", border: "border-4 border-secondary" },
  { icon: Globe2, name: "Social Studies", desc: "History, geography & civics that connect to the world around them.", tone: "secondary" },
  { icon: Languages, name: "Hindi", desc: "Vyakaran, reading & writing skills, aligned to the school syllabus.", tone: "white", border: "border-4 border-primary" },
  { icon: Leaf, name: "EVS", desc: "Environmental studies for younger grades, made hands-on and fun.", tone: "white", border: "border-4 border-secondary" },
  { icon: Monitor, name: "Computers", desc: "Digital literacy and foundational computer skills by grade level.", tone: "white", border: "border-4 border-primary" },
  { icon: ScrollText, name: "Sanskrit / GK", desc: "Supporting subjects and general knowledge to round out learning.", tone: "accent" },
];

const toneClass = {
  primary: "bg-primary text-primary-foreground",
  secondary: "bg-secondary text-secondary-foreground",
  accent: "bg-accent text-accent-foreground",
  white: "bg-white text-foreground",
};

export const CoreSubjects = () => (
  <section id="courses" className="py-24 md:py-32 max-w-7xl mx-auto px-5 md:px-8">
    <Reveal>
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <Overline>Core curriculum · Classes 1–8</Overline>
          <h2 className="font-heading font-bold text-4xl md:text-5xl tracking-tight max-w-xl">Every core subject, taught to your child's board.</h2>
          <p className="mt-4 text-muted-foreground max-w-lg">Complete coverage of the school syllabus with structured lessons, regular assessments and doubt-clearing — matched to your board and academic calendar.</p>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="board-badges">
          {boards.map((b) => (
            <span key={b} className="rounded-full bg-primary/10 text-primary font-label text-sm font-semibold px-4 py-2 border border-primary/15">{b}</span>
          ))}
        </div>
      </div>
    </Reveal>

    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
      {subjects.map((s, i) => {
        const Icon = s.icon;
        return (
          <Reveal key={s.name} delay={0.05 * i}>
            <div className={`rounded-3xl p-7 h-full hover:-translate-y-2 transition-transform duration-300 ${toneClass[s.tone]} ${s.border || ""}`} data-testid={`core-subject-${s.name.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
              <Icon size={28} className="mb-5" />
              <h3 className="font-heading font-bold text-xl">{s.name}</h3>
              <p className={`mt-2 text-sm ${s.tone === "white" ? "text-muted-foreground" : "opacity-90"}`}>{s.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default CoreSubjects;
